var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rbv-progress-bar" }, [
    _c("div", {
      staticClass: "percent",
      style: { width: `${_vm.percentage}%` },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }